import React from 'react';
import { DatePicker, Checkbox, Select } from 'antd';
import { toast } from 'react-toastify';
import services from '../../services';
import { withRouter } from 'react-router-dom';
import FormleftNev from '../common/FormleftNev';
import EntityFilter from '../common/EntityFilter'
import queryString, { parse } from 'query-string'
import FormNavbar from '../common/wizard_navbar';
import Lang from '../../lang'
import { Input, TextArea } from '@progress/kendo-react-inputs';
import $ from "jquery";
import { string } from 'prop-types';
const moment = require('moment');

const { Option } = Select
const InputFieldsAll = {
    DetalhesPenhora: [
        {
            key: "CodFrasesPersonalizadas",
            type: "number",
            display: "CodFrasesPersonalizadas"
        },
        {
            key: "TituloFrasesPersonalizadas",
            type: "text",
            display: "TituloFrasesPersonalizadas"
        },
        {
            key: "TextoFrasesPersonalizadas",
            type: "textArea",
            display: "TextoFrasesPersonalizadas"
        }
    ],
    ProdutosFrasesPersonalizadas: [
        {
            key: "Produto Douro",
            type: "multiselect",
            display: "Produto Douro"
        },
        
    ],
   
}

let apiFilters = {
    Filters: null,
    SortBy: 'ID',
    Page: 1,
    PageSize: 100,
    Filters: null,
    IsSortTypeDESC: false,
    IsPagination: false,
    
};

class PedidosAjudaForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idMarcaLocalizacao: 0,
            codEstatuto: [],
            codEntidade: 0,
            ruleList: [],
            entityList: [],
            titulo: '',
            cod: '',
            descricao: '',
            id :'',
            error:null,
            isChecked: true,
            ProdutosFrases: [],
            ProdutosSelecionados: []
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        let parsed = queryString.parse(window.location.search)
        if(parsed.id){
            this.getEntidadeById(parsed.id)
        }
        var filter = {};
        (async () => {
            const ProdutosFrases = await services.apiCall.requestApi("Marcas/GetProdutosCertificados", filter, 'get')
            this.setState({ ProdutosFrases });
        })();
		 
    }

    handleChangeMarcaLocalizacao = (e) => {
        this.setState({ idMarcaLocalizacao: e });
    }
    handleChangeTitulo = (e) => {
        this.setState({ titulo: e.value });
    }
    handleChangeCod = (e) => {
        this.setState({ cod: e.value });
    }
    handleChangeTexto = (e) => {
        this.setState({ descricao: e.value });
    }
    createInputs(nevkey) {
        let inputs = InputFieldsAll[nevkey].map((row, i) => {
            switch (row.type) {
                case "multiselect":
                    return (
                        
                       
                        <React.Fragment key={i}>
                            {console.log("FRASES", this.state.ProdutosFrases)}
                            {this.state.ProdutosSelecionados.length > 0 && (
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Selecione"
                                    className="estatoSelect"
                                    mode="multiple"
                                    onChange={(e) => this.handleChangeMarcaLocalizacao(e)}
                                    style={{ width: "100%", marginTop:"10px", marginLeft:"15px" , marginRight:"15px" }}
                                    defaultValue={this.state.ProdutosSelecionados}
                                >
                                    <Option disabled>Selecione</Option>
                                    {(this.state.ProdutosFrases && !!this.state.ProdutosFrases.length) && this.state.ProdutosFrases.map((item, index) => (
                                        <Option key={index} value={item.idproduto}>{item.desproduto}</Option>
                                    ))}
                                </Select>
                                )}
                        {this.state.ProdutosSelecionados.length == 0 && (
                            <Select
                                showSearch
                                optionFilterProp="children"
                                placeholder="Selecione"
                                className="estatoSelect"
                                mode="multiple"
                                onChange={(e) => this.handleChangeMarcaLocalizacao(e)}
                                style={{ width: "100%", marginTop:"10px", marginLeft:"15px" , marginRight:"15px" }}
                                //defaultValue={this.state.ProdutosSelecionados}
                            >
                                <Option disabled>Selecione</Option>
                                {(this.state.ProdutosFrases && !!this.state.ProdutosFrases.length) && this.state.ProdutosFrases.map((item, index) => (
                                    <Option key={index} value={item.idproduto}>{item.desproduto}</Option>
                                ))}
                            </Select>
                            )}
                    </React.Fragment>
                    );
                break;
                case "checkbox":
                    return (
                        <div className="custom-control mt-3 ml-3 custom-checkbox">
                            <input type="checkbox" onChange={(e) => this.handleCheck(e)} className="custom-control-input" id={`customCheck-${i}`} name={row.key}  />
                            <label className="custom-control-label" htmlFor={`customCheck-${i}`}>{row.display}</label>
                        </div>
                    )
                    break;
                case "textArea":
                    return(
                        <div className="col-md-12">
                            <div className="input-box active-grey" style={{marginTop:"25px"}}>
                            <label style={{position: "absolute",zIndex: "1",top: "-12px",left: "16px",backgroundColor: "white"}} className='k-label'>Texto</label>
                                <TextArea
                                    id={row.key}
                                    name={row.key}
                                    type={row.type}
                                    style={{ width: "100%" , height: "200px",padding: "0" , paddingTop:"11px" }}
                                    className="input-1 k-textbox textareaFrases"
                                    label={"Texto"}
                                    row={50}
                                    cols={50}
                                    value={this.state ? this.state.descricao : ""}
                                    onChange={(e) => this.handleChangeTexto(e)}
                                />
                                
                            </div>
                        </div>
                    )
                break;
                default:
                    if(row.display == 'TituloFrasesPersonalizadas'){
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.titulo : ""}
                                        onChange={(e) => this.handleChangeTitulo(e)}
                                    />
                                </div>
                            </div>
                        )
                    }else{
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.cod : ""}
                                        onChange={(e) => this.handleChangeCod(e)}
                                    />
                                </div>
                            </div>
                        )
                    }   
            }
        });
        return inputs
    }

    handleSelect = (value) => {
        try {
            this.setState({
                codEstatuto: value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    handleEntitySelect = (value) => {
        try {
            this.setState({
                codEntidade: +value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    createInputFields = () => {
        try {
            let InputFieldsdivs = Object.keys(InputFieldsAll).map((nevkey) => {
                return (<div className="bg-white middle p20" id={nevkey}>
                    <div className="head" style={{marginBottom: "1px"}}>
                        <h2> {Lang.langCheck.langRequest(`${nevkey}`)}</h2>
                       
                    </div>
                    <div className="row">
                        {this.createInputs(nevkey)}
                    </div>
                </div>
                )
            });
    
            return InputFieldsdivs;
        } catch (error) {
            this.setState({error})
        }
    }

    getEntidadeById = async (id) => {
        try {
            let parsed = queryString.parse(window.location.search)
            if(parsed.id){
                var data = {id: parsed.id}
            }else{
                var data = {id: "0"}
            }

            let _user = await services.apiCall.requestApi(
                "/Rotulos/GetTipoReprovacao",
                data,
                "get"
            );
            if (_user) {
                
                var resp = _user.filter((item, index) => item.idTipoReprovacaoEncrypt === decodeURIComponent(id))
                if (resp.length> 0) {
                    this.setState({
                        titulo: resp[0].titulo,
                        descricao: resp[0].descricao,
                        id : resp[0].idTipoReprovacao,
                        ProdutosSelecionados: resp[0].produtos,
                        cod: String(resp[0].codTipoReprovacao)
                    })
                }
            }  
        } catch (error) {
            this.setState({error})
        }
    }

    handleSubmit = (e, backUrl) => {
        e.preventDefault();
        try {
            let parsed = queryString.parse(window.location.search)
                if(parsed.id != undefined && parsed.id != null){
                // é o update
                    this.handleAddandUpdateFrases(parsed.id, backUrl);
                } else {
                    // adiciona novo
                    this.handleAddandUpdateFrases(null,backUrl);
                }
            
        } catch (error) {
            this.setState({error})
        }
    }

    handleAddandUpdateFrases = async (id, backUrl) => {
        try {
            if(id){
                var data = {
                    IdTipoReprovacaoEncrypt: id,
                    titulo: $("#TituloFrasesPersonalizadas").val(),
                    texto: $("#TextoFrasesPersonalizadas").val(),
                    idProdutos : this.state.idMarcaLocalizacao == 0 ? [] : this.state.idMarcaLocalizacao,
                    criadoPor:  window.localStorage.getItem('username')
                }
                var res = await services.apiCall.requestApi(`/Rotulos/UpdateFrasesPersonalizadas`, data, 'post')
                if (res) {
                    if (backUrl) {
                        this.props.history.push({
                            pathname: backUrl,
                            state:{topBarMenu : this.props.topBarMenuOption}
                        })
                    }
                }
            }else{
                if($("#CodFrasesPersonalizadas").val() != ""){
                    var data = {
                        IdTipoReprovacaoEncrypt: "",
                        titulo: $("#TituloFrasesPersonalizadas").val(),
                        texto: $("#TextoFrasesPersonalizadas").val(),
                        idProdutos : this.state.idMarcaLocalizacao == 0 ? [] : this.state.idMarcaLocalizacao,
                        criadoPor:  window.localStorage.getItem('username'),
                        codTipoReprovacao: parseInt($("#CodFrasesPersonalizadas").val()),
                    }
                    var res = await services.apiCall.requestApi(`/Rotulos/AddFrasesPersonalizadas`, data, 'post')
                    if (res) {
                        if (backUrl) {
                            this.props.history.push({
                                pathname: backUrl,
                                state:{topBarMenu : this.props.topBarMenuOption}
                            })
                        }
                    }
                }else{
                    toast.error("o campo Cod é de preenchimento obrigatório");
                } 
            }
            
        } catch (error) {
            this.setState({error})
        }
    }

    checkRequestData = () => {
        if(this.state.codEntidade == 0 || this.state.codEstatuto.length == 0){
            return false
        }else{
            return true
        }
    }

    handleCreateEntityEstatutoList = async (backUrl) => {
        try {
            let data = {
                codEntidade: this.state.codEntidade,
                codEstatuto: this.state.codEstatuto,
            }
            let res ;
            let {isChecked} = this.state;
            if(isChecked || !backUrl){
            res= await services.apiCall.requestApi('/BusEntidadeEstatuto/Create', data, 'post')
            }
            if (res) {
                this.setState({
                    isChecked: false,
                })
               
            }
            if (backUrl ) {
                this.props.history.push({
                    pathname: '/entity_rule_list',
                    state:{topBarMenu : this.props.topBarMenuOption}
                })
            }
        } catch (error) {
            this.setState({error})
        }

    }

    render() {
        console.log("state",this.state)
        console.log("props",this.props)
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="dashboard">
                {
                    
                        <FormNavbar to={'/admin_dashboard_frases'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Pedido de ajuda" />
                }
                <div className="full-container edit-ward">
                    <FormleftNev InputFieldsAll={InputFieldsAll} />
                    <div className="right-section">

                        <div className="row top-serch">
                            {
                                this.createInputFields()
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(PedidosAjudaForm);